var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.8496C0.5 11.0097 0.652819 8.76178 1.04824 6.98253C1.4424 5.20896 2.07094 3.9319 3.00142 3.00142C3.9319 2.07094 5.20896 1.4424 6.98253 1.04824C8.76178 0.652819 11.0097 0.5 13.8496 0.5H18.1504C20.9903 0.5 23.2382 0.652819 25.0175 1.04824C26.791 1.4424 28.0681 2.07094 28.9986 3.00142C29.9291 3.9319 30.5576 5.20896 30.9518 6.98253C31.3472 8.76178 31.5 11.0097 31.5 13.8496V18.1504C31.5 20.9903 31.3472 23.2382 30.9518 25.0175C30.5576 26.791 29.9291 28.0681 28.9986 28.9986C28.0681 29.9291 26.791 30.5576 25.0175 30.9518C23.2382 31.3472 20.9903 31.5 18.1504 31.5H13.8496C11.0097 31.5 8.76178 31.3472 6.98253 30.9518C5.20896 30.5576 3.9319 29.9291 3.00142 28.9986C2.07094 28.0681 1.4424 26.791 1.04824 25.0175C0.652819 23.2382 0.5 20.9903 0.5 18.1504V13.8496Z",
    stroke: "#9EBCC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquircleOutline);
export default __webpack_public_path__ + "static/media/squircle-outline.bb048658c211f850370b41beacde8b3b.svg";
export { ForwardRef as ReactComponent };